/**
 * For security reasons we encode and decode the composition that is rendered in our HTML markup.
 * We adopted this by the Hypernova project.
 * See here: https://github.com/airbnb/hypernova/blob/master/src/index.js#L22
 */

/**
 * Special chars that we don't want in the HTML markup
 * @type {string[][]}
 */
const toBeEncodedChars = [
  ['&', '&amp;'],
  ['>', '&gt;'],
  ['</', '&lt;/'],
];

/**
 * Encoding the composition and make it a string
 * @param obj
 * @return {string}
 */
function encode(obj) {
  return toBeEncodedChars.reduce((str, coding) => {
    const [encodeChar, htmlEntity] = coding;
    return str.replace(new RegExp(encodeChar, 'g'), htmlEntity);
  }, JSON.stringify(obj));
}

/**
 * Decoding the compoosition and make it JSON
 * @param res
 * @return {any}
 */
function decode(res) {
  const jsonPayload = toBeEncodedChars.reduceRight((str, coding) => {
    const [encodeChar, htmlEntity] = coding;
    return str.replace(new RegExp(htmlEntity, 'g'), encodeChar);
  }, res);

  return JSON.parse(jsonPayload);
}

/**
 *
 * @param {string} str
 * @returns {string} string without leading or trailing html comment tags
 */
function trimHTMLCommentTags(str) {
  return str.replace(/^(<!--)|(-->)$/gm, '').trim();
}

/**
 *
 * @param {string} id representing the composition's html element
 * @returns {null|object} composition as object
 */
function getCompositionByElementId(id) {
  const ssrCompositionElement = document.getElementById(id);
  if (ssrCompositionElement && ssrCompositionElement.innerText && ssrCompositionElement.innerText !== '') {
    return decode(trimHTMLCommentTags(ssrCompositionElement.innerText));
  }

  return null;
}

export { encode, decode, getCompositionByElementId, trimHTMLCommentTags };
